export const ru = {
    'allowed-page-id-is-not-number': 'pageId должно быть положительным числом, ошибки в значениях: {values}',
    'allowed_page-ids-limit-reached': 'общее количество запрещенных pageId не может превышать: {limit}',
    and: 'и',
    'autobuget-campaign-name': 'Автобюджетная кампания',
    'banned-domains-limit-reached': 'Максимальное количество площадок/внешних сетей: {limit}',
    'content-promotion-campaign-name': 'Кампания "Продвижение контента"',
    'empty-campaign-name': 'Не указано название кампании',
    experiments: 'Экспериментов',
    'invalid-disabled-ips-number': 'Общее количество запрещенных IP-адресов не может превышать {maxIpsNumber}',
    'invalid-ips': 'Неверно указаны IP-адреса: {ips}',
    'key-goals': 'Ключевых целей',
    'max-length-name': 'Название кампании не должно превышать {count} символов',
    'metrika-counters-is-unavailable': {
        one:
            'Счетчик метрики {counters} нельзя привязать к кампании. Счетчик удален или нет прав на его использование.',
        some:
            'Счетчики метрики {counters} нельзя привязать к кампании. Счетчики удалены или нет прав на их использование.',
        many:
            'Счетчики метрики {counters} нельзя привязать к кампании. Счетчики удалены или нет прав на их использование.',
        none:
            'Счетчики метрики {counters} нельзя привязать к кампании. Счетчики удалены или нет прав на их использование.'
    },
    'name-campaign': '{campaignName} №{count} от {date}',
    'price-package-campaign-name': 'Пакетная кампания',
    'required-field': 'Обязательное поле',
    'tgo-campaign-name': 'Текстово-графическая кампания',
    'warning-about-metrika-counters':
        'При удалении счетчиков, потеряются все настройки {fields} по соответствующим целям'
};
